import { itemDefinitionsTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  milestoneConfig: [],
  CountItems: 0,
  isLoading: false,
  error: {},
};

const ItemDefintions = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case itemDefinitionsTypes.GET_ITEM_DEFINITIONS:
      return {
        ...state,
        isLoading: true,
      };
    case itemDefinitionsTypes.GET_ITEM_DEFINITIONS_SUCCESS:
      return {
        ...state,
        data: action.payload.ItemDefinitionData,
        CountItems: action.payload.CountItems,
        isLoading: false,
      };

    case itemDefinitionsTypes.GET_ITEM_DEFINITIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
      case itemDefinitionsTypes.GET_MILESTONESCONFIG_IV_SUCCESSS:
        return{
          ...state,
          milestoneConfig: action.payload
        }
  
    case itemDefinitionsTypes.GET_MILESTONESCONFIG_IV_FAIL:
          return{
            ...state,
            error: action.payload,
          }

    default:
      return state;
  }
};

export default ItemDefintions;
